export enum ConsolidationPackingSortDimension {
  Grade = "grade",
  Product = "product",
}
